import React, { FC } from 'react'
import { Box, BoxProps } from '@mui/material'
import loaderData from '../lib/lotties/loader.json'
import Lottie from 'lottie-react'

interface CustomLoaderProps {
	showLoader?: boolean
	sx?: BoxProps['sx']
	size?: 'small' | 'medium'
	isFullScreen?: boolean
}

export const CustomLoader: FC<CustomLoaderProps> = ({
	showLoader = true,
	sx,
	size = 'medium',
	isFullScreen = true,
}) => {
	if (!showLoader) {
		return null
	}

	const sizeValue = size === 'small' ? 100 : 200

	return (
		<Box
			sx={{
				backgroundColor: 'rgba(255,255,255, 0.5)',
				display: 'flex',
				justifyContent: 'center',
				position: isFullScreen ? 'fixed' : 'absolute',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 3,
				alignItems: 'center',
				overflow: 'hidden',
				...sx,
			}}
		>
			<Lottie
				animationData={loaderData}
				loop={true}
				style={{ width: sizeValue, height: sizeValue }}
			/>
		</Box>
	)
}
